@if (initialized && model) {
  <div>
    @if (step === 'info') {
      <app-subscription-one-downgrade-cu
        (next)="onDowngradeInfo($event)"
        [selectedCus]="model.cu"
        (backEvent)="onDowngradeInfoBack()"
        [historyBack]="false"
        [subscription]="model.subscription">
      </app-subscription-one-downgrade-cu>
    }
    @if (step === 'address') {
      <app-invoice-address
        (next)="onInvoiceAddress($event)"
        [onlyEmit]="true"
        (backEvent)="onInvoiceAddressBack()"
        [historyBack]="false"
        >
      </app-invoice-address>
    }
    @if (isSepa && step === 'payment') {
      <app-payment-method
        (next)="onPaymentMethod($event)"
        [onlyEmit]="true"
        (backEvent)="onPaymentMethodBack()"
        [historyBack]="false"
        [paymentMethod]="model?.saleOrder?.payment_method ?? model?.subscription?.payment_method"
        >
      </app-payment-method>
    }
    @if (step === 'checkout') {
      <app-checkout-one-summary
        [subscription]="model.subscription"
        (back)="onSummaryBack()"
        [historyBack]="false"
        (buy)="onBuy()"
        >
      </app-checkout-one-summary>
    }
    @if (step === 'complete') {
      <app-endcustomer-downgrade-order-complete
        (next)="onComplete()"
        >
      </app-endcustomer-downgrade-order-complete>
    }
  </div>
}
